import App from './App.vue'
import routes from './router'
new Vue({
  router: routes,
  components:{ App }
 }).$mount('#app')